import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { addPageAction, getNewRelic } from '@lib/newrelic/agent'

const cleanPath = (url: string): string => url.split('?')[0]

/**
 * SPA route tracking para el New Relic Browser agent (Pages Router).
 *
 * El agente auto-instrumenta los cambios de history como BrowserInteractions;
 * aquí solo mejoramos el naming del page view por ruta y dejamos una page
 * action explícita por navegación. Los errores globales (window.onerror /
 * unhandledrejection) los captura el feature `jserrors` del agente, por lo que
 * NO se enganchan aquí para evitar doble conteo.
 */
export const useNewRelic = (): void => {
    const router = useRouter()

    useEffect(() => {
        // Se suscribe siempre; el agente puede cargar async (import dinámico),
        // así que se resuelve dentro del handler, no al montar.
        const handleRouteChangeComplete = (url: string): void => {
            const nr = getNewRelic()
            if (!nr) {
                return
            }
            const path = cleanPath(url)
            nr.setPageViewName(path)
            addPageAction('spaRouteChange', { path })
        }

        router.events.on('routeChangeComplete', handleRouteChangeComplete)

        return () => {
            router.events.off('routeChangeComplete', handleRouteChangeComplete)
        }
    }, [router.events])
}

export default useNewRelic
